import { PublicPage } from '../base.js';

export class Logout extends PublicPage {
  static timl = `
    section.logout-page[aria-labelledby="logout-title"]
      .logout-status[role="status"]
        .logout-status-icon[aria-hidden="true"]
        h1#logout-title Logged out
        p Your tokens have been cleared.
        a.logout-login-button[href="/login"]
          span.logout-login-arrow[aria-hidden="true"]
          span Back to login
  `;

  static css = `
    body:has(.logout-page) > aside {
      display: none;
    }

    body:has(.logout-page) > main {
      width: 100%;
      min-height: 100vh;
      padding: 6px 12px 8px;
    }

    body:has(.logout-page) main .page,
    body:has(.logout-page) main .page .max-width-center {
      min-height: calc(100vh - 14px);
    }

    body:has(.logout-page) main .page {
      border-radius: 9px;
      overflow: hidden;
    }

    .logout-page {
      display: flex;
      min-height: calc(100vh - 16px);
      align-items: center;
      justify-content: center;
      padding: 24px 24px 9vh;
      text-align: center;
    }

    .logout-status {
      display: flex;
      flex-direction: column;
      align-items: center;
      color: #17212d;
    }

    .logout-status-icon {
      position: relative;
      width: 104px;
      height: 104px;
      margin-bottom: 25px;
      border: 1px solid #dedfe1;
      border-radius: 50%;
      background: #fafafa;
    }

    .logout-status-icon::before {
      content: "";
      position: absolute;
      top: 34px;
      left: 38px;
      width: 29px;
      height: 15px;
      border-bottom: 6px solid #17212d;
      border-left: 6px solid #17212d;
      transform: rotate(-45deg);
    }

    .logout-status h1 {
      margin: 0;
      color: #17212d;
      font-size: 38px;
      font-weight: 700;
      line-height: 46px;
      letter-spacing: -0.035em;
    }

    .logout-status p {
      margin: 13px 0 37px;
      color: #4f5965;
      font-size: 18px;
      font-weight: 500;
      line-height: 26px;
    }

    .logout-login-button {
      display: inline-flex;
      min-width: 199px;
      min-height: 54px;
      align-items: center;
      justify-content: center;
      gap: 22px;
      padding: 0 24px;
      border: 1px solid #25303c;
      border-radius: 8px;
      background: #fff;
      color: #25303c;
      font-size: 16px;
      font-weight: 600;
      line-height: 22px;
      transition: background-color 140ms ease, color 140ms ease, box-shadow 140ms ease;
    }

    .logout-login-button:hover {
      background: #f6f6f6;
      color: #111923;
      box-shadow: 0 2px 5px rgba(0, 0, 0, 0.07);
    }

    .logout-login-button:focus-visible {
      outline: 3px solid rgba(23, 33, 45, 0.18);
      outline-offset: 3px;
    }

    .logout-login-arrow {
      position: relative;
      width: 19px;
      height: 14px;
    }

    .logout-login-arrow::before,
    .logout-login-arrow::after {
      content: "";
      position: absolute;
    }

    .logout-login-arrow::before {
      top: 6px;
      left: 0;
      width: 18px;
      height: 2px;
      border-radius: 2px;
      background: currentColor;
    }

    .logout-login-arrow::after {
      top: 2px;
      left: 0;
      width: 8px;
      height: 8px;
      border-bottom: 2px solid currentColor;
      border-left: 2px solid currentColor;
      transform: rotate(45deg);
    }

    @media (max-width: 600px) {
      body:has(.logout-page) > main {
        padding: 6px;
      }

      .logout-page {
        min-height: calc(100vh - 12px);
        padding: 24px 20px 6vh;
      }

      .logout-status-icon {
        width: 88px;
        height: 88px;
      }

      .logout-status-icon::before {
        top: 28px;
        left: 32px;
        width: 25px;
        height: 13px;
        border-width: 0 0 5px 5px;
      }

      .logout-status h1 {
        font-size: 33px;
        line-height: 41px;
      }
    }
  `;

  static javascript() {
    Auth.resetSuiteBootstrap();
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    document.body.className = "unauthenticated";
    Auth.user = {};
  }
}
